import React from 'react';
import { LoadingCircle } from '@icarros/ids-react';
import { LoadingWrapper } from './style';

interface LoadingProps {
  isInner?: boolean;
  backgroundOnly?: boolean;
}

export function Loading({ isInner, backgroundOnly }: LoadingProps): React.JSX.Element {
  return (
    <LoadingWrapper isInner={isInner} backgroundOnly={backgroundOnly}>
      {!backgroundOnly && <LoadingCircle active />}
    </LoadingWrapper>
  );
}
